var createComponentsFromObject = function (object, extraOptions) {
    if (extraOptions === void 0) { extraOptions = {}; }
    var counter = 0;
    /**
     * This counter means for creating constant componentKeys for
     * components which does not have it by default. There are some
     * related logics to key attribute to each component of an array
     * in the inner React functionalities which causes this need to use
     * a constant value instead of random ones.
     *
     * Everytime the whole component tree is rerendered, the counter value
     * is reset.
     * */
    function incrementCounter() {
        return counter++;
    }
    var buildBranch = require('../../builder/builder').default;
    if (!object)
        return;
    // @ts-ignore
    if (Array.isArray(object.Children)) {
        /**
         * Added this to support new version (no-object) configuration.
         * Initial object passed to this function supposed to be an object
         * containing objects of component definition. But this newer approach
         * accepts the component definition as well. Because it is not important
         * for the builder to get an object of components.
         * */
        object = {
            root: object
        };
    }
    var componentList = Object.keys(object);
    if (componentList.length === 0)
        return;
    componentList.sort();
    return componentList.map(function (key) {
        return buildBranch(key, object[key], {
            counter: counter,
            level: 0,
            increment: incrementCounter
        }, extraOptions);
    });
};
export default createComponentsFromObject;
